import { PagesPilotFeatureFlags } from '@Hooks/dataFetching/usePagesPilotFeatureFlags';
import { getContextId } from '@tlx/astro-shared';
import { Outlet } from 'react-router';
import { usePilotFeatureContext } from '@Component/PilotFeatureContext/PilotFeatureContext.tsx';

const getLinkWithContextId = (link: string) => {
    const contextId = getContextId();
    const url = new URL(link, window.location.origin);
    url.searchParams.set('contextId', contextId ?? '');
    return url.toString();
};

export const PilotFeatureProtectedRoute = ({
    hasPageAccess,
    redirectUrl,
}: {
    hasPageAccess(pilotFeatureFlags: PagesPilotFeatureFlags): boolean;
    redirectUrl: string;
}) => {
    const redirectUrlWithContextId = getLinkWithContextId(redirectUrl);
    const pilotFeatureContext = usePilotFeatureContext();

    if (!hasPageAccess(pilotFeatureContext)) {
        window.location.replace(redirectUrlWithContextId);
    }

    return <Outlet />;
};
